<script>
	import Index from './fried-egg.svelte';
	function playAgain() {
    window.location.reload();
  }
  </script>
  
  <main>
  <br>
  <br>
  <br>
  <br>
  <h1> move the egg to pan !! </h1>
	<button on:click={playAgain}>Play Again</button>
	<Index />
  </main>
<style>

</style>